/* @jsxImportSource @emotion/react */

import React from 'react'
import { useIntl } from 'react-intl'

import { SectionFAQ } from '../../components/SectionFAQ'
import { SectionLastCTA } from '../../components/SectionLastCTA'
import { SlitePage } from '../../components/SlitePage'
import { useRoutes } from '../../routes'
import { getPricingFAQ } from './data'
import { SectionPricingFeatures } from './SectionPricingFeatures'
import { SectionPricingPlans } from './SectionPricingPlans'
import { SectionPricingQuotes } from './SectionPricingQuotes'

export default function IndexPage() {
  const intl = useIntl()
  const routes = useRoutes()
  const pageTitle = intl.formatMessage({
    id: 'pricing.title',
    defaultMessage: 'Slite - Pricing',
  })
  const pageDescription = intl.formatMessage({
    id: 'pricing.description',
    defaultMessage:
      'Simple, flexible pricing to meet your documentation needs. Choose the right plan for your team.',
  })
  const pageImage =
    'https://cdn.sanity.io/images/dnsgqii5/production/084d4e7ad9e0dcdf4edf4a75e498cdc92e51fa7a-1200x630.jpg'

  const [isYearly, setIsYearly] = React.useState(true)

  return (
    <SlitePage
      title={pageTitle}
      description={pageDescription}
      ogImage={pageImage}
      ogTitle={pageTitle}
      ogDescription={pageDescription}
      canonicalUrl={routes.pricing()}
      background="moon-dust-lighter"
    >
      <SectionPricingPlans isYearly={isYearly} setIsYearly={setIsYearly} />
      <SectionPricingFeatures isYearly={isYearly} />
      <SectionPricingQuotes />
      <SectionFAQ faq={getPricingFAQ(intl)} />
      <SectionLastCTA background="moon-dust-lighter" />
    </SlitePage>
  )
}
